<template>
  <!-- 配载批次 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div
      class="glo_btnList"
      ref="btnList"
    >
      <div class="glo_btnList_left">
        <!-- <el-button v-if="hasPermiss('admin:dispatch:initDispatch')" class="glo_btnItems glo_bgcMainColor" @click="transportPlan">新建配载</el-button> -->
        <el-button
          v-if="hasPermiss('admin:dispatch:dispatchSure')"
          class="glo_btnItems"
          @click="dispatchSure()"
        >调度确认</el-button>
        <el-button
          v-if="hasPermiss('admin:dispatch:cancelDispatch')"
          class="glo_btnItems"
          @click="cancelDispatch()"
        >取消调度确认</el-button>
        <el-button
          v-if="hasPermiss('admin:dispatch:receiveOrder')"
          class="glo_btnItems"
          @click="receiveOrder()"
        >司机接单</el-button>
        <el-button
          v-if="hasPermiss('admin:dispatch:startCar')"
          class="glo_btnItems"
          @click="startCar()"
        >出车确认</el-button>
        <el-button
          v-if="hasPermiss('admin:dispatch:endCar')"
          class="glo_btnItems"
          @click="wtl_endCar()"
        >出车完成</el-button>
        <!-- <el-button v-if="hasPermiss('admin:dispatch:initDispatch')" class="glo_btnItems" @click="yantuzhuanghuo()">沿途装卸</el-button> -->
        <el-button
          v-if="hasPermiss('admin:dispatch:postingDispatch')"
          class="glo_btnItems"
          @click="fcGuoZhang()"
        >发车单过账</el-button>
        <el-button
          v-if="hasPermiss('admin:dispatch:unpostingDispatch')"
          class="glo_btnItems"
          @click="fcFanGuoZhang()"
        >发车单反过账</el-button>
        <el-button
          class="glo_btnItems"
          @click="Canceldepartureconfirmation()"
        >取消发车确认</el-button>
        <el-button
          class="glo_btnItems"
          @click="Canceldriversorderreception()"
        >取消司机接单</el-button>
        <el-button
          class="glo_btnItems"
          @click="delDispatch()"
        >删除批次</el-button>
        <el-dropdown
          class="topDropDown"
          @command="topCommandBtns"
        >
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="printBtns">打印</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          ></multitime>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="运单号:"
        >
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.waybillNumber"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="车牌号:"
        >
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.carNumber"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="挂车号码:"
        >
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.trailerNumber"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="车型:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.carTypeConfDictId"
            placeholder="请输入"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="(item, index) in car_type_list"
              :key="index"
              :label="item.key"
              :value="item.confDictId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="调度状态:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.dispatchStatus"
            placeholder="请输入"
            @focus="getStatusValLists('bill_tms_dispatch_v3.dispatch_status')"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="(item, index) in dispatch_status_list"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="司机名称:"
        >
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.driverName"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="押运员名称:"
        >
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.supercargoName"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="车次创建人:"
        >
          <el-select
            v-model="queryData.createUserId"
            clearable
            remote
            filterable
            :remote-method="
              (query) => {
                getAccountList(query);
              }
            "
            @clear="getAccountList()"
            @focus="getAccountList()"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in customerArr"
              :key="index"
              :label="item.username"
              :value="item.userId"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="发车批次号:"
        >
          <el-input
            placeholder="请输入"
            clearable
            v-model="queryData.number"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'memberNickname' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                class="linkTabel"
                @click.stop="goYdDetails(scope.row)"
              >
                {{ scope.row.memberNickname }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="250px"
        >
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="hasPermiss('admin:dispatch:saveDispatchTask')"
                class="rbtns"
                @click.stop="WaybillEdit(scope.row)"
              >修改</el-button>
              <el-button
                v-if="hasPermiss('aaaaa')"
                class="rbtns"
                @click.stop="details(scope.row)"
              >详情</el-button>
              <!-- <el-button v-if="hasPermiss('admin:dispatch:arrangeDriver')" class="rbtns" @click.stop="anPaiSiJi(scope.row)">安排司机</el-button> -->
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item
                    v-if="hasPermiss('admin:dispatch:saveDispatchRoute')"
                    command="a"
                    >调整线路</el-dropdown-item
                  >-->
                  <!-- <el-dropdown-item command="费用录入">费用录入</el-dropdown-item> -->
                  <el-dropdown-item command="费用补录">费用补录</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:dispatch:saveAllocationCarFee')"
                    command="c"
                  >车费分摊</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:dispatch:saveCommission')"
                    command="d"
                  >提成分摊</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:dispatch:delDispatch')"
                    command="e"
                  >删除批次</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('aaaaa')"
                    command="printBtns"
                  >打印</el-dropdown-item>
                  <!-- <el-dropdown-item command="b">入库确认</el-dropdown-item>
                  <el-dropdown-item command="b">出库确认</el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 安排司机 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="isShowDialog"
      :width="diaWidth"
      :close-on-click-modal="false"
      @close="handleCloseDia"
    >
      <slot>
        <div class="glo_dialogForm">
          <el-form
            v-if="isShowDialog"
            class="diaForm"
            ref="dialogFormREF"
            :model="dialogForm"
            label-width="120px"
            :rules="rulesForm"
          >
            <el-form-item
              class="dialogFormItems"
              prop="carCategoryConfDictId"
              label="车辆类型:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogForm.carCategoryConfDictId"
                placeholder="请选择"
                @change="changecarCategoryConfDictId"
              >
                <el-option
                  v-for="(item, index) in car_categoryList"
                  :key="index"
                  :label="item.key"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="isTractor"
              label="是否牵引车:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogForm.isTractor"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isTractorList"
                  :key="item.val"
                  :label="item.name"
                  :value="item.val"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="carNumber"
              label="车牌号码:"
            >
              <el-select
                filterable
                clearable
                allow-create
                remote
                v-model="dialogForm.carNumber"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in carNumberList"
                  :key="index"
                  :label="item.carNumber"
                  :value="item.carNumber"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 是否牵引车,是,挂车号必填 -->
            <el-form-item
              v-if="dialogForm.isTractor"
              class="dialogFormItems"
              prop="trailerNumber"
              label="挂车号码:"
            >
              <!-- <el-input
                v-model="dialogForm.trailerNumber"
                placeholder="请输入"
              ></el-input>-->
              <el-select
                filterable
                clearable
                allow-create
                remote
                :remote-method="getcarNumberRmethod"
                v-model="dialogForm.trailerNumber"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in carNumberList2"
                  :key="index"
                  :label="item.carNumber"
                  :value="item.carNumber"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 是否牵引车,否,挂车号不是必填 -->
            <el-form-item
              v-if="!dialogForm.isTractor"
              class="dialogFormItems"
              prop
              label="挂车号码:"
            >
              <!-- <el-input
                v-model="dialogForm.trailerNumber"
                placeholder="请输入"
              ></el-input>-->
              <el-select
                filterable
                clearable
                allow-create
                remote
                :remote-method="getcarNumberRmethod"
                v-model="dialogForm.trailerNumber"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in carNumberList2"
                  :key="index"
                  :label="item.carNumber"
                  :value="item.carNumber"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="dispatchContractNumber"
              label="发车合同号:"
            >
              <el-input
                v-model="dialogForm.dispatchContractNumber"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="driverOneId"
              label="司机一:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogForm.driverOneId"
                placeholder="请选择"
                @change="changeDriver"
              >
                <el-option
                  v-for="(item, index) in driverList"
                  :key="index"
                  :label="item.name"
                  :value="item.documentId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="driverTwoId"
              label="司机二:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogForm.driverTwoId"
                placeholder="请选择"
                @change="changeDriver2"
              >
                <el-option
                  v-for="(item, index) in driverList"
                  :key="index"
                  :label="item.name"
                  :value="item.documentId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="supercargoOneId"
              label="押运员一:"
            >
              <el-select
                v-model="dialogForm.supercargoOneId"
                placeholder="请选择"
                filterable
                clearable
                @change="changeDriver3"
              >
                <el-option
                  v-for="(item, index) in driverList"
                  :key="index"
                  :label="item.name"
                  :value="item.documentId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems"
              prop="supercargoTwoId"
              label="押运员二:"
            >
              <el-select
                v-model="dialogForm.supercargoTwoId"
                placeholder="请选择"
                filterable
                clearable
                @change="changeDriver4"
              >
                <el-option
                  v-for="(item, index) in driverList"
                  :key="index"
                  :label="item.name"
                  :value="item.documentId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="dialogFormItems dialogTims"
              prop="planDepartureTime"
              label="计划发车时间:"
            >
              <el-date-picker
                class="input"
                value-format="yyyy-MM-dd"
                v-model="dialogForm.planDepartureTime"
                type="date"
                placeholder="选择日期"
                @change="queryBtn_ok"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </slot>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          class="diaBtns"
          style="margin-right: 30px"
          size="mini"
          @click="handleCloseDia"
        >关 闭</el-button>
        <el-button
          class="diaBtns"
          style="margin-right: 30px"
          type="primary"
          size="mini"
          @click="diaConfirmBtn1('dialogFormREF', 'SAVE')"
        >保存</el-button>
        <el-button
          class="diaBtns glo_bgcMainColor"
          type="primary"
          size="mini"
          @click="diaConfirmBtn1('dialogFormREF', 'DISPATCH')"
        >保存并调度</el-button>
      </span>
    </el-dialog>

    <!-- 出车确认 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('formRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog2"
          ref="formRef"
          class="diaForm"
          :model="dialogForm2"
          label-width="120px"
          :rules="rulesForm2"
        >
          <el-form-item
            style="width: 100%"
            prop="startMileage"
            label="出发前公里数"
          >
            <el-input
              clearable
              style="border: 1px solid #e3e3e3"
              v-model="dialogForm2.startMileage"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="出车检查项">
            <el-checkbox-group v-model="dialogForm2.checkItemConfDictIds">
              <el-checkbox
                v-for="(item, index) in start_car_check_item_list"
                :key="index"
                :label="item.confDictId"
                name="type"
              >{{ item.key }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="出发前图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
          <el-form-item
            style="width: 100%"
            label="出发备注"
          >
            <el-input
              type="textarea"
              placeholder
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 出车完成 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3('dialogForm3Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog3"
          class="diaForm"
          ref="dialogForm3Ref"
          :model="dialogForm3"
          label-width="100px"
          :rules="rulesForm3"
        >
          <el-form-item
            style="width: 100%; margin-right: 0"
            class="dialogFormItems"
            prop="endMileage"
            label="完成公里数:"
          >
            <el-input
              type="number"
              v-model="dialogForm3.endMileage"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dislogFormTextarea"
            prop="remarks"
            label="备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm3.remarks"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList3"
              :fileNameLists="fileNameLists3"
              :limit="6"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 沿途装卸 -->
    <myDialog
      :diaWidth="diaWidth4"
      :dialogTitle="dialogTitle4"
      :isShowDialog="isShowDialog4"
      @handleCloseDia="handleCloseDia4"
      @diaCancelBtn="handleCloseDia4"
      @diaConfirmBtn="diaConfirmBtn4('dialogForm4Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog4"
          class="diaForm"
          ref="dialogForm4Ref"
          :model="dialogForm4"
          label-width="140px"
          :rules="rulesForm4"
        >
          <el-form-item
            style="width: 100%; margin-right: 0"
            class="dialogFormItems"
            prop="endMileage"
            label="关联主发车批次号:"
          >
            <el-input
              v-model="dialogForm4.parentNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!--  发车批次过账-->
    <myDialog
      :diaWidth="diaWidth5"
      :dialogTitle="dialogTitle5"
      :isShowDialog="isShowDialog5"
      @handleCloseDia="handleCloseDia5"
      @diaCancelBtn="handleCloseDia5"
      @diaConfirmBtn="diaConfirmBtn5('dialogForm5Ref')"
    >
      <div>
        <caiwuxinxi
          :tableDataYF="tableData51"
          :tableDataYS="tableData52"
          @delIconsYF="delIconsYF"
          @delIconsYS="delIconsYS"
          @diaConfirmBtnS="diaConfirmBtnS"
        ></caiwuxinxi>
      </div>
    </myDialog>

    <!-- <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>-->

    <!-- ======================打印组件======================== -->
    <!-- <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>-->

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <!-- 时间组件 -->
          <el-form-item class="queryItemsTimes">
            <multitime
              :timeType="timeType"
              :timeTypes="timeTypes"
              :startTime="startTime_a"
              :endTime="endTime_a"
              @timestatus="timestatus"
              @queryBtn_ok="queryBtn_time"
            ></multitime>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="运单号:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="queryData.waybillNumber"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="车牌号:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="queryData.carNumber"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="挂车号码:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="queryData.trailerNumber"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="车型:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.carTypeConfDictId"
              placeholder="请输入"
              @change="queryBtn_ok"
            >
              <el-option
                v-for="(item, index) in car_type_list"
                :key="index"
                :label="item.key"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="调度状态:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.dispatchStatus"
              placeholder="请输入"
              @focus="getStatusValLists('bill_tms_dispatch_v3.dispatch_status')"
              @change="queryBtn_ok"
            >
              <el-option
                v-for="(item, index) in dispatch_status_list"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            class="queryItems"
            label="司机名称:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="queryData.driverName"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="押运员名称:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="queryData.supercargoName"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="发车批次号:"
          >
            <el-input
              placeholder="请输入"
              clearable
              v-model="queryData.number"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>

    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="调度配载模块"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleOk"
    ></printDialog>

    <!-- 创建和使用模板 -->
    <printSys
      :printForm="printForm"
      :title="printTitle"
      icon="el-icon-printer"
      @handleClose="handlePrintSysClose"
    >
      <printSysContent
        :printType="printType"
        :modelObj="modelObj"
        :modelClassName="modelClassName"
        :selectTableData="selectTableData"
      ></printSysContent>
    </printSys>

    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select
        v-model="modelClassName"
        placeholder
        style="width: 100%"
      >
        <el-option
          v-for="(value, key) in classNameArr"
          :key="key"
          :label="value.name"
          :value="value.val"
        ></el-option>
      </el-select>
    </classNameDialog>
    <!-- ======================打印组件======================== -->
  </div>
</template>
<script>
import sorttable from '@/components/sortTemplate.vue' //自定义排序表头
import paging from '@/components/pagings.vue' //分页组件
import multitime from '@/components/multiTime.vue'
import myDialog from '@/components/Dialog.vue'
import queryBtns from '@/components/queryBtns.vue'
import uploadimgs from '@/components/upLoadImgs.vue'
import caiwuxinxi from '@/components/caiWuXinXi.vue'
// import prints from "@/components/prints/printA.vue";
import { mixin_print } from '@/assets/js/Mixins/mixinPrint'
import exportjs from '@/assets/js/Mixins/export.js' //导出的公共js

export default {
  mixins: [mixin_print, exportjs],
  inject: ['reload'],
  components: {
    sorttable,
    paging,
    multitime,
    myDialog,
    uploadimgs,
    queryBtns,
    caiwuxinxi,
    // prints,
  },
  data() {
    return {
      customerArr: [],
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: '',
        fileName: '配载批次列表',
        apiName: '/admin/v3/tms/dispatch/getDispatchList', //导出的数据列表接口名
        EpType: 'bdd', //dd==等待下载完成,bdd==不等待完成
        apiType: 'GET', //导出当前列表的请求方式
        pageType: 'VehicleStowage', //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      tableData51: [],
      tableData52: [],
      car_type_list: [], //车型
      car_categoryList: [], //车型
      driverList: [], //司机列表
      carNumberList: [], //车辆列表(车牌号码)
      carNumberList2: [], //车辆列表(挂车牌号码)
      dispatch_status_list: [], //调度状态
      delTb51: [],
      delTb52: [],
      //  -----  查询  ------
      queryData: {
        carNumber: '',
        carTypeConfDictId: '',
        dispatchStatus: '',
        driverName: '',
        supercargoName: '',
        trailerNumber: '',
        waybillNumber: '',
        createUserId: '',
        number: '',
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: '0',
          label: '创建日期',
        },
        {
          value: '1',
          label: '发车日期',
        },
      ],
      timeType: '0', //  时间类型
      startTime_a: '',
      endTime_a: '',

      MoreConditions: '更多条件', //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: '75vh', //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: '预计发车时间',
          field: 'planDepartureTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发车批次号',
          field: 'number',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '车次属性',
          field: 'dispatchPropertyShow',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '提货指令编号',
          field: 'commandNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '车牌号码',
          field: 'carNumber',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '挂车号码',
          field: 'trailerNumber',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '车次状态',
          field: 'dispatchStatusShow',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '任务票数',
          field: 'taksCount',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '包含运单号',
          field: 'waybillNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '费用合计',
          field: 'financeOutAmount',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '是否过账',
          field: 'isPostingShow',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '结算对象类型',
          field: 'objectStatus',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '结算对象',
          field: 'objectName',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '付款方式',
          field: 'paymentMethod',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '申请报销状态',
          field: 'applyReimburseStatus',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '司机名称',
          field: 'driverName',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '司机电话',
          field: 'driverPhone',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '司机身份证',
          field: 'driverIdcard',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '押运员名称',
          field: 'supercargoName',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发货员',
          field: 'sendNotifierName',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '随车人员',
          field: 'carFollowPersonnelName',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '总重量(kg)',
          field: 'totalWeight',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '总体积(m³)',
          field: 'totalVolume',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '车型',
          field: 'carType',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '车辆类型',
          field: 'carCategory',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '司机属性',
          field: 'driverAttribute',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发车合同编号',
          field: 'dispatchContractNumber',
          width: '180',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '行驶里程数',
          field: 'mileage',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '开始里程数',
          field: 'startMileage',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '结束里程数',
          field: 'endMileage',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '单趟载重率',
          field: 'loadRate',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '标准满载率',
          field: 'fullLoadRate',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发车确认时间',
          field: 'departureTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '出车完成时间',
          field: 'completeTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '创建时间',
          field: 'createTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '创建人',
          field: 'createUserName',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '任务类型',
          field: 'transportPlanShow',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发车类型',
          field: 'departureTypeShow',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '关联主批次号',
          field: 'parentNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '途径站点数',
          field: 'stationCount',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '出入库状态',
          field: 'stockStatusShow',
          width: '120',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '最大载重(kg)',
          field: 'loadableCapacity',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '最大体积(m³)',
          field: 'loadableVolume',
          width: '106',
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: '调度司机列表', //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: '', //  导出需要
      pageGroupName: 'VehicleStowage', //  页面标识

      fileNameLists: [], //上传组件的
      fileNameLists3: [], //上传组件的(出车完成图片)
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: '',
      diaWidth: '40%',
      dialogForm: {
        // 弹窗表单数据
        carCategoryConfDictId: '',
        dispatchId: '',
        driverOneId: '',
        driverOneName: '',
        saveType: '',
        carNumber: '',
        dispatchContractNumber: '',
        driverTwoId: '',
        driverTwoName: '',
        supercargoOneId: '',
        supercargoOneName: '',
        supercargoTwoId: '',
        supercargoTwoName: '',
        trailerNumber: '',
        isTractor: 0,
        planDepartureTime: '',
      },
      rulesForm: {
        carCategoryConfDictId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
        driverOneId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
        carNumber: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
        trailerNumber: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
        planDepartureTime: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: '',
      diaWidth2: '40%',
      dialogForm2: {
        // 弹窗表单数据
        startMileage: '',
        remarks: '',
        checkItemConfDictIds: [],
        dispatchIds: [],
      },
      rulesForm2: {
        carCategoryConfDictId: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] },
        ],
        startMileage: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog3: false,
      dialogTitle3: '',
      diaWidth3: '40%',
      dialogForm3: {
        // 弹窗表单数据
        endMileage: '',
        remarks: '',
        fileIds: [],
        dispatchIds: [],
      },
      rulesForm3: {
        endMileage: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog4: false,
      dialogTitle4: '',
      diaWidth4: '40%',
      dialogForm4: {
        parentNumber: '',
      },
      rulesForm4: {
        parentNumber: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====
      // ==== 弹窗组件属性 start ====
      isShowDialog5: false,
      dialogTitle5: '',
      diaWidth5: '80%',
      dialogForm5: {
        dispatchId: '',
        number: '',
      },
      rulesForm5: {
        parentNumber: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      start_car_check_item_list: [], //出车检测项
      carTypeCId: '',
      dataList: [],
      topData: {},

      isTractorList: [
        { val: 0, name: '否' },
        { val: 1, name: '是' },
      ],

      // 打印插件 每个页面不一样的
      // 模板className
      idarrs: [],
      classNameArr: [
        {
          name: '车辆成本付款清单',
          val: 'com.bami.service.tms.v3.admin.print.vo.AdminCarCostPrintDataV3tmsVo',
        },
        {
          name: '发车配载清单',
          val: 'com.bami.service.tms.v3.admin.print.vo.AdminDispatchPrintDataV3tmsVo',
        },
      ],
      // 默认的模板类型
      modelClassName: '',
    }
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1
      }
      this.tabelHeadeTitle = arr
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      )
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum) //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate() //今天的时间;;
    this.getData()
    this.getConfDictValDownLists('car_type')

    //获取默认表头
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName)
  },
  activated() {
    // 每次进页面都会触发的写这里
  },
  mounted() {},
  watch: {},
  methods: {
    // 获取账号列表
    getAccountList(name) {
      let param = {
        // name: name || "",
        username: name || '',
        pageStart: 1,
        pageTotal: 100,
      }
      this.$API.wtl_getAccountList(param).then((res) => {
        let datas = res.data.result.data || []
        let list =
          datas.filter(
            (item) => item.userStatus == 'zheng_chang:user_status'
          ) || []
        this.customerArr = list
      })
    },
    // ==================打印插件==================
    // 打印按钮
    printEvent(val) {
      let idarr = []
      if (val) {
        idarr.push(val.dispatchId)
        this.selectTableData = [val]
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请选择需要打印的数据')
          return false
        }
        idarr = this.selectTableData.map((item) => {
          return item.dispatchId
        })
      }
      console.log('idarr', idarr)
      this.idarrs = idarr

      window.sessionStorage.setItem(
        'set_PrintSelectTableData',
        JSON.stringify(idarr)
      )
      this.dialogFrom.dialogVisible = true
    },
    // 打印预览模板
    handleView(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      })
      let idarr = this.idarrs || []
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }

      if (obj.className == this.classNameArr[0].val) {
        // 获取车辆成本打印数据
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == 'success') {
                const result = res.data.result
                hiprintTemplate.print(result, {})
              }
            }
          })
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == 'success') {
                const result = res.data.result
                hiprintTemplate.print(result, {})
              }
            }
          })
      }
    },
    // 打印-确定模板的数据
    handleOk(obj) {
      console.log(obj, 'obj')
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      })
      let idarr = this.idarrs || []
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }
      if (obj.className == this.classNameArr[0].val) {
        this.$API
          .getCarCostPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == 'success') {
                const result = res.data.result
                hiprintTemplate.print(result, {})
              }
            }
          })
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getDispatchPrintData({
            dipatchIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == 'success') {
                const result = res.data.result
                hiprintTemplate.print(result, {})
              }
            }
          })
      }
    },

    // ==================打印插件==================

    // 获取财务信息
    wtl_getDispatchFinance(dispatchId) {
      this.$API
        .wtl_getDispatchFinance({ dispatchId: dispatchId })
        .then((res) => {
          let financeInReqs = res.data.result.financeInVos || [] //应收
          let financeOutReqs = res.data.result.financeOutVos || [] //应付

          financeInReqs.forEach((item) => {
            item.operationType = 'UPDATE'
          })
          financeOutReqs.forEach((item) => {
            item.operationType = 'UPDATE'
          })

          this.tableData51 = financeOutReqs
          this.tableData52 = financeInReqs
        })
    },
    // 根据字典类型获取字典值下拉列表 getConfDictValDownLists(car_category)
    getConfDictValDownLists(val) {
      this.$COMAPI.getConfDictValDownList(val).then((res) => {
        //车型
        if (val == 'car_type') {
          this.car_type_list = res || []
        }
        //车辆分类
        if (val == 'car_category') {
          this.car_categoryList = res || []
        }
      })
    },
    // 获取状态下拉列表
    getStatusValLists(val) {
      this.$TOOLS.getStatusValList(val).then((res) => {
        // 调度状态
        if (val == 'bill_tms_dispatch_v3.dispatch_status') {
          this.dispatch_status_list = res || []
        }
      })
    },
    // 根据对象类型获取对象的下拉列表 getObjectUserDownList('driver')
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == 'driver') {
          this.driverList = res || []
        }
      }) //获取网点列表
    },
    // 选择司机
    changeDriver(e) {
      if (e) {
        this.driverList.forEach((item) => {
          if (item.documentId == e) {
            this.dialogForm.driverOneName = item.name
          }
        })
      } else {
        this.dialogForm.driverOneName = ''
      }
    },
    // 选择司机2
    changeDriver2(e) {
      if (e) {
        this.driverList.forEach((item) => {
          if (item.documentId == e) {
            this.dialogForm.driverTwoName = item.name
          }
        })
      } else {
        this.dialogForm.driverTwoName = ''
      }
    },
    // 选择押运1
    changeDriver3(e) {
      if (e) {
        this.driverList.forEach((item) => {
          if (item.documentId == e) {
            this.dialogForm.supercargoOneName = item.name
          }
        })
      } else {
        this.dialogForm.supercargoOneName = ''
      }
    },
    // 选择押运2
    changeDriver4(e) {
      if (e) {
        this.driverList.forEach((item) => {
          if (item.documentId == e) {
            this.dialogForm.supercargoTwoName = item.name
          }
        })
      } else {
        this.dialogForm.supercargoTwoName = ''
      }
    },
    // 获取车辆下拉列表(拿车牌号码)
    getcarNumber(carNumber, carCategoryConfDictId, carTypeConfDictId) {
      this.$API
        .CarDownList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: carNumber || '',
          carCategoryConfDictId: carCategoryConfDictId || '', //车辆分类id
          carTypeConfDictId: carTypeConfDictId || '', //车型id
        })
        .then((res) => {
          this.carNumberList = res.data.result.data || []
        })
    },
    // 获取车辆下拉列表(拿挂车号码)
    getcarNumber2(carNumber) {
      this.$API
        .CarArchiveList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: carNumber || '',
        })
        .then((res) => {
          let arrs = res.data.result.data || []
          // let arr2 = [];
          // arrs.forEach((item) => {
          //   if (item.trailerNumber) {
          //     arr2.push(item);
          //   }
          // });
          this.carNumberList2 = arrs
        })
    },
    getcarNumberRmethod(e) {
      console.log('e', e)
      this.getcarNumber2(e)
    },
    // 选择车型
    changecarCategoryConfDictId(e) {
      console.log('e', e)
      this.dialogForm.carNumber = ''
      if (e) {
        this.getcarNumber('', e, this.carTypeCId)
      }
    },

    // 安排司机
    anPaiSiJi(row) {
      this.getConfDictValDownLists('car_category')
      this.isShowDialog = true
      this.dialogTitle = '安排司机'
      this.dialogForm.dispatchId = row.dispatchId

      this.getObjectUserDownList('driver')
      // console.log(this.car_type_list);
      this.getcarNumber2() //挂车号码

      this.car_type_list.forEach((item) => {
        if (item.key == row.carType) {
          this.carTypeCId = item.confDictId
        }
      })
      // getcarNumber carType
      // 获取司机信息
      this.$API
        .wtl_getDispatchCarInfo({ dispatchId: row.dispatchId })
        .then((res) => {
          let datas = res.data.result || ''
          if (datas) {
            this.getcarNumber('', datas.carCategoryConfDictId, this.carTypeCId)
            this.dialogForm = {
              carCategoryConfDictId: datas.carCategoryConfDictId,
              dispatchId: datas.dispatchId,
              driverOneId: datas.driverOneId,
              driverOneName: datas.driverOneName,
              saveType: '',
              carNumber: datas.carNumber,
              dispatchContractNumber: datas.dispatchContractNumber,
              driverTwoId: datas.driverTwoId,
              driverTwoName: datas.driverTwoName,
              supercargoOneId: datas.supercargoOneId,
              supercargoOneName: datas.supercargoOneName,
              supercargoTwoId: datas.supercargoTwoId,
              supercargoTwoName: datas.supercargoTwoName,
              trailerNumber: datas.trailerNumber || '',
              isTractor: datas.isTractor,
              planDepartureTime: datas.planDepartureTime,
            }
          }
        })
    },
    //  xxx
    details(row) {
      this.$router.push({
        path: '/DispatchCar/dispatchCarDetails',
        query: {
          dispatchId: row.dispatchId,
          ptype: 'details',
        },
      })
    },

    // 修改
    WaybillEdit(row) {
      // this.$router.push({
      //   path: "/DispatchCar/NewStowageEdit",
      //   query: {
      //     dispatchId: row.dispatchId || "",
      //     number_s: row.number || "",
      //     carType: row.carType || "",
      //   },
      // });
      this.$router.push({
        path: '/DispatchCar/NewStowageEditRX',
        query: {
          dispatchId: row.dispatchId || '',
          transportPlan: row.transportPlan || '',
          transportType: row.transportType || '',
          pageJumpType: 'edit',
        },
      })
    },
    transportPlan() {
      this.$router.push({
        path: '/DispatchCar/NewStowageAdd',
      })
    },
    // 调度确认
    dispatchSure() {
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要调度确认的任务')
        return false
      }
      let ids = []
      this.selectTableData.forEach((item) => {
        ids.push(item.dispatchId)
      })
      this.$confirm('确定要把所选任务进行调度确认吗?', '提示')
        .then(() => {
          this.$API.dispatchSure({ dispatchIds: ids }).then((res) => {
            this.$message.success(res.data.message || '调度确认成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 取消调度
    cancelDispatch() {
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要取消调度的任务')
        return false
      }
      let ids = []
      this.selectTableData.forEach((item) => {
        ids.push(item.dispatchId)
      })
      this.$confirm('确定要把所选任务进行取消调度吗?', '提示')
        .then(() => {
          this.$API.cancelDispatch({ dispatchIds: ids }).then((res) => {
            this.$message.success(res.data.message || '取消调度成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 确认接单
    receiveOrder() {
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要确认接单的任务')
        return false
      }
      let ids = []
      this.selectTableData.forEach((item) => {
        ids.push(item.dispatchId)
      })
      this.$confirm('确定要把所选任务进行确认接单吗?', '提示')
        .then(() => {
          this.$API.wtl_receiveOrder({ dispatchIds: ids }).then((res) => {
            this.$message.success(res.data.message || '确认接单成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 出车确认
    startCar() {
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要出车确认的任务')
        return false
      }
      let ids = []
      this.selectTableData.forEach((item) => {
        ids.push(item.dispatchId)
      })
      this.dialogForm2.dispatchIds = ids

      this.isShowDialog2 = true
      this.dialogTitle2 = '出车确认'

      this.$COMAPI
        .getConfDictValDownList('start_car_check_item')
        .then((res) => {
          this.start_car_check_item_list = res || []
          this.dialogForm2.checkItemConfDictIds = res.map((item) => {
            return item.confDictId
          })
        }) //出车检查项
    },
    // 出车完成
    wtl_endCar() {
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要出车完成的任务')
        return false
      }
      let ids = []
      this.selectTableData.forEach((item) => {
        ids.push(item.dispatchId)
      })
      this.dialogForm3.dispatchIds = ids

      this.isShowDialog3 = true
      this.dialogTitle3 = '出车完成'
    },
    // 沿途装货
    yantuzhuanghuo() {
      // if (this.selectTableData.length < 1) {
      //   this.$message.warning("请选择需要出车完成的任务");
      //   return false;
      // }
      // let ids = [];
      // this.selectTableData.forEach((item) => {
      //   ids.push(item.dispatchId);
      // });
      // this.dialogForm4.dispatchIds = ids;

      this.isShowDialog4 = true
      this.dialogTitle4 = '沿途装货'
    },
    // 过账
    fcGuoZhang() {
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要过账的批次')
        return false
      }
      if (
        !this.selectTableData.every((item) => {
          return item.isPosting == 0
        })
      ) {
        this.$message.warning('所选有已过账的批次')
        return false
      }
      if (
        !this.selectTableData.every((item) => {
          return item.applyReimburseStatus == '否'
        })
      ) {
        this.$message.warning('所选有已申请报销的批次，已申请报销不能过账')
        return false
      }
      let ids = this.selectTableData.map((item) => {
        return item.dispatchId
      })
      this.$confirm('确认要把所选的批次单进行 过账 吗? 请谨慎操作')
        .then(() => {
          this.$API.batchPostingDispatch({ dispatchIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
      // let id = "";
      // if (this.selectTableData.length < 1) {
      //   this.$message.warning("请选择一条需要过账的任务");
      //   return false;
      // }
      // if (this.selectTableData.length > 1) {
      //   this.$message.warning("一次只能过账一条发车任务哦");
      //   return false;
      // }
      // id = this.selectTableData[0].dispatchId;

      // this.$router.push({
      //   path: "/DispatchCar/VehicleStowage/ExpenseSupplementaryRecording",
      //   query: {
      //     number: this.selectTableData[0].number,
      //     dispatchId: id,
      //   },
      // });

      // this.dialogForm5.dispatchId = id;
      // this.dialogForm5.number = this.selectTableData[0].number;
      // this.wtl_getDispatchFinance(id);

      // this.isShowDialog5 = true;
      // this.dialogTitle5 = "发车单过账";
    },
    // 反过账
    fcFanGuoZhang() {
      //
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要反过账的批次')
        return false
      }
      let ids = this.selectTableData.map((item) => {
        return item.dispatchId
      })
      this.$confirm('确认要把所选的批次单进行 反过账 吗? 请谨慎操作')
        .then(() => {
          this.$API.wtl_unpostingDispatch({ dispatchIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 取消发车确认
    Canceldepartureconfirmation() {
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要取消发车确认的批次')
        return false
      }
      let ids = this.selectTableData.map((item) => {
        return item.dispatchId
      })
      this.$confirm('确认要把所选的批次单进行 取消发车确认 吗? 请谨慎操作')
        .then(() => {
          this.$API.cancelStartCar({ dispatchIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 取消司机接单
    Canceldriversorderreception() {
      if (this.selectTableData.length < 1) {
        this.$message.warning('请选择需要取消司机接单的批次')
        return false
      }
      let ids = this.selectTableData.map((item) => {
        return item.dispatchId
      })
      this.$confirm('确认要把所选的批次单进行 取消司机接单 吗? 请谨慎操作')
        .then(() => {
          this.$API.cancelReceiveOrder({ dispatchIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
    },

    // 删除
    delDispatch(val) {
      // 右边单选
      let ids = []
      if (val) {
        ids.push(val.dispatchId)
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请至少选择一条数据进行操作').showClose = true
          return false
        }

        ids = this.selectTableData.map((item) => {
          return item.dispatchId
        })
      }
      // 上面多选
      this.$confirm('确定要删除所选数据吗?', '提示:')
        .then(() => {
          this.$API.delDispatch({ dispatchIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            let that = this
            setTimeout(() => {
              that.getData()
            }, 1000)
          })
        })
        .catch(() => {})
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    // 选择图片(出车完成)
    changeFileList3(array) {
      this.fileNameLists3 = array
      console.log('fileNameLists3', this.fileNameLists3)
    },
    // 选择出车检测项
    changeCheckBox(e) {},
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false
      this.dialogForm = {
        carCategoryConfDictId: '',
        dispatchId: '',
        driverOneId: '',
        driverOneName: '',
        saveType: '',
        carNumber: '',
        dispatchContractNumber: '',
        driverTwoId: '',
        driverTwoName: '',
        supercargoOneId: '',
        supercargoOneName: '',
        supercargoTwoId: '',
        supercargoTwoName: '',
        trailerNumber: '',
        isTractor: 0,
        planDepartureTime: '',
      }
    },
    //  弹窗确认保存事件
    diaConfirmBtn1(formName, saveType) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dialogForm))
          param.saveType = saveType //SAVE = 保存 ; DISPATCH = 保存并调度
          if (param.planDepartureTime) {
            param.planDepartureTime = param.planDepartureTime + ' 00:00:00'
          }

          this.$API.wtl_arrangeDriver(param).then((res) => {
            this.$message.success(res.data.message || '').showClose = true
            this.isShowDialog = false
            this.getData()
          })
        }
      })
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia3() {
      this.isShowDialog3 = false
      this.dialogForm3 = {}
    },
    //  弹窗确认保存事件  出车完成
    diaConfirmBtn3(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let fids = []
          this.fileNameLists3.forEach((item) => {
            fids.push(item.name)
          })
          let datas = JSON.parse(JSON.stringify(this.dialogForm3))
          let param = {
            dispatchIds: datas.dispatchIds || 0,
            endMileage: datas.endMileage || 0,
            remarks: datas.remarks || '',
            fileIds: fids,
          }
          this.$API.wtl_endCar(param).then((res) => {
            this.$message.success(res.data.message || '')
            this.isShowDialog3 = false
            this.getData()
          })
        }
      })
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia4() {
      this.isShowDialog4 = false
      this.dialogForm4 = {
        parentNumber: '',
      }
    },
    //  弹窗确认保存事件  沿途装货
    diaConfirmBtn4(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            departureType: 'yan_tu_zhuang_huo:departure_type',
            carTypeConfDictId: '',
            parentNumber: this.dialogForm4.parentNumber,
          }
          this.$API.wtl_initDispatch(param).then((res) => {
            // this.$message.success(res.data.message || "新建成功");
            this.$confirm(
              '已生成发车批次号: ' +
                res.data.result.number +
                ' 是否立即分配任务',
              '提示:',
              {
                confirmButtonText: '稍后分配',
                cancelButtonText: '分配任务',
              }
            )
              .then(() => {
                this.getData()
                this.isShowDialog4 = false
              })
              .catch(() => {
                this.isShowDialog4 = false
                this.$router.push({
                  path: '/DispatchCar/NewStowageAdd',
                  query: {
                    dispatchId: res.data.result.dispatchId || '',
                    pageType: 'yanTu',
                  },
                })
              })
          })
        }
      })
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia5() {
      this.isShowDialog5 = false
      this.delTb51 = []
      this.delTb52 = []
      this.tableData51 = []
      this.tableData52 = []
      this.dialogForm5 = {
        dispatchId: '',
        number: '',
      }
    },
    delIconsYF(e, array1) {
      this.delTb51 = e || []
      this.tableData51 = array1
    },
    delIconsYS(e, array2) {
      this.delTb52 = e || []
      this.tableData52 = array2
    },
    diaConfirmBtnS(array1, array2) {
      this.tableData51 = array1
      this.tableData52 = array2
    },
    //  弹窗确认保存事件  过账
    diaConfirmBtn5() {
      let data1 = JSON.parse(JSON.stringify(this.tableData51)) || []
      let data2 = JSON.parse(JSON.stringify(this.tableData52)) || []
      let delTb51 = JSON.parse(JSON.stringify(this.delTb51)) || []
      let delTb52 = JSON.parse(JSON.stringify(this.delTb52)) || []
      let financeOutReqs = [...data1, ...delTb51]
      let financeInReqs = [...data2, ...delTb52]

      let param = {
        financeInReqs: financeInReqs, //应收
        financeOutReqs: financeOutReqs, //应付
        dispatchId: this.dialogForm5.dispatchId,
      }
      this.$API.wtl_postingDispatch(param).then((res) => {
        this.$message.success(res.data.message || '操作成功')
        this.getData()
        this.isShowDialog5 = false
      })
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false
      this.dialogForm2 = {
        startMileage: '',
        remarks: '',
        checkItemConfDictIds: [],
        dispatchIds: [],
      }
      this.fileNameLists = []
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let fids = this.fileNameLists.map((item) => {
            return item.name
          })
          let param = {
            checkItemConfDictIds: this.dialogForm2.checkItemConfDictIds,
            dispatchIds: this.dialogForm2.dispatchIds,
            remarks: this.dialogForm2.remarks,
            startMileage: this.dialogForm2.startMileage,
            fileIds: fids,
          }
          this.$API.wtl_startCar(param).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.isShowDialog2 = false
            this.getData()
          })
        }
      })
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      this.$router.push({
        path: '/WaybillManage/WaybillDetails',
        query: {
          yd: '123',
        },
      })
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || ''
      this.endTime_a = e || ''
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || '0'
      this.startTime_a = s || ''
      this.endTime_a = e || ''
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row)
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row)
    },

    getData() {
      let param = JSON.parse(JSON.stringify(this.queryData))

      let startDepartureTime = ''
      let startCreateTime = ''
      let endDepartureTime = ''
      let endCreateTime = ''
      let startTime = this.startTime_a ? this.startTime_a + ' 00:00:00' : ''
      let endTime = this.endTime_a ? this.endTime_a + ' 23:59:59' : ''
      if (this.timeType == '0') {
        // 创建日期
        startCreateTime = startTime
        endCreateTime = endTime
      } else if (this.timeType == '1') {
        // 发车日期
        startDepartureTime = startTime
        endDepartureTime = endTime
      }

      param.startCreateTime = startCreateTime
      param.endCreateTime = endCreateTime
      param.startDepartureTime = startDepartureTime
      param.endDepartureTime = endDepartureTime
      param.pageStart = this.pageStart
      param.pageTotal = this.pageTotal

      this.$API.wtl_getDispatchList(param).then((res) => {
        this.className = res.data.result.className || ''
        this.tableData = res.data.result.data || []
        this.pageCount = res.data.result.pageCount || 0
        this.fetTableHeight()
      })
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1
      this.getData()
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        carNumber: '',
        carTypeConfDictId: '',
        dispatchStatus: '',
        driverName: '',
        supercargoName: '',
        trailerNumber: '',
        createUserId: '',
        number: '',
      }
      this.pageStart = 1
      this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum) //开始时间;
      this.endTime_a = this.$TOOLS.getCurrentDate() //今天的时间;;
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore
      if (this.isHaseMore) {
        this.MoreConditions = '收起条件'
      } else {
        this.MoreConditions = '更多条件'
      }

      this.$nextTick(() => {
        this.fetTableHeight()
      })
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val
      this.getData()
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val
      this.getData()
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: '/BusinessManagement/addPacks',
      })
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: '/BusinessManagement/addPacks',
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        })
      } else {
        this.$message.error('请选一个需要修改的包裹').showClose = true
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: '/BusinessManagement/packsDetails',
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        })
      } else {
        this.$router.push({
          path: '/BusinessManagement/packsDetails',
        })
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            'chu_ku_zai_tu:package_status' ||
          this.selectTableData[0].packageStatus ==
            'ke_hu_qian_shou:package_status' ||
          this.selectTableData[0].packageStatus ==
            'chu_ku_zhong:package_status' ||
          this.selectTableData[0].packageStatus ==
            'da_bao_wan_cheng:package_status'
        ) {
          this.$router.push({
            path: '/BusinessManagement/dabaoDetails',
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          })
        } else {
          this.$message.error('包裹未打包完成').showClose = true
        }
      } else {
        this.$message.error('请选择一个包裹').showClose = true
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this
      const { columns, data } = param

      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(this.$TOOLS.add(prev, curr), 2)
                } else {
                  return prev
                }
              }, 0)
              sums[index] += ''
            } else {
              sums[index] = '---'
            }
          }
        }
      })
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
      return sums
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight //页面高度
      let queryHeigth = 40 + 10 //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10 //查询框
      }
      let pagsHeigth = 40 + 20 //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60 //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || '' //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight
        this.$refs.mytable.doLayout()
      })
    },

    // 打印相关的
    handleCloseDia_print() {
      this.isShowDialog_print = false
    },
    // 打印预览确定
    diaConfirmBtn_print() {
      this.isShowDialog_print = false
    },
    // 打印相关的

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === 'bgsz') {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this)
      }

      if (a === 'jtdc') {
        // 新版导出
        this.isShowDialog_dc = true
      }
      if (a === 'printBtns') {
        this.printEvent()
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: '表名(暂无效)', //表名
      })
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      // a==调整线路
      if (type == '费用录入') {
        this.$router.push({
          path: '/DispatchCar/VehicleStowage/ExpenseEntry',
          query: {
            dispatchId: val.dispatchId,
          },
        })
      }
      if (type == '费用补录') {
        this.$router.push({
          path: '/DispatchCar/VehicleStowage/ExpenseSupplementaryRecording',
          query: {
            number: val.number,
            dispatchId: val.dispatchId,
          },
        })
      }
      if (type === 'a') {
        // this.$router.push({
        //   path: "/DispatchCar/NewStowageEdit",
        //   query: {
        //     dispatchId: val.dispatchId || "",
        //     pageType: "tzxl",
        //   },
        // });
      }
      // c==车费分摊
      if (type === 'c') {
        this.$router.push({
          path: '/DispatchCar/FareAllocation',
          query: {
            dispatchId: val.dispatchId,
          },
        })
      }
      // d==提成分摊
      if (type === 'd') {
        if (!val.driverName) {
          this.$message.error('请先安排司机并调度确认')
          return false
        }
        if (val.dispatchStatus === 'wei_fen_pei:dispatch_status') {
          this.$message.error('请先调度确认')
          return false
        }
        this.$router.push({
          path: '/DispatchCar/RoyaltyApportionment',
          query: {
            dispatchId: val.dispatchId,
          },
        })
      }

      // e==删除
      if (type == 'e') {
        this.delDispatch(val)
      }

      if (type === 'printBtns') {
        // 打印标签
        // this.$API
        //   .wtl_getDispatchTaskList({
        //     dispatchId: val.dispatchId,
        //   })
        //   .then((res) => {
        //     let datas = res.data.result.data || [];
        //     this.dataList = datas;
        //     this.topData = val;
        //     console.log("dataList", this.dataList);
        //     this.isShowDialog_print = true;
        //   });
        //
        this.printEvent(val)
      }
    },

    //    -------------  设置列表表头方法  ------------

    getGroupFindFieldSort() {
      //  获取自定义的排序,没有就用默认的
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || []
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.myTableHeard = JSON.parse(arr[0].sortObject)
              this.sortName = arr[0].sortName
            }
          } else {
            this.myTableHeard = this.tabelHeadeTitle
          }
          let totalArr = []
          //提取需要合计的字段
          for (var i = 0; i < this.myTableHeard.length; i++) {
            if (this.myTableHeard[i].isTotal) {
              totalArr.push(this.myTableHeard[i].field)
            }
          }
          this.totalArr = totalArr
        })
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
    },

    // ==========排序表头的组件方法==========
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      // this.tabelHeadeTitle = e;
      // this.myTableHeard = this.tabelHeadeTitle;
      // let sortObject = this.myTableHeard;
      // let sign = "";
      // //   let param = {
      // //     groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
      // //     sortName: this.sortName, //综合查询接口路径
      // //     sortObject: JSON.stringify(sortObject),
      // //     sign: sign,
      // //   };
      // //   this.$API.pushFindFieldSort(param).then((res) => {
      // //     this.$message.success(res.data.message || "操作成功");
      // //     this.getGroupFindFieldSort();
      // //   });
      // this.show_sortTableHeard = false; //关闭弹窗
      // this.$nextTick(() => {
      //   this.$refs.mytable.doLayout();
      // });
      // this.show_sortTableHeard = false;

      this.tabelHeadeTitle = e
      this.myTableHeard = this.tabelHeadeTitle
      let sortObject = this.myTableHeard
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      }
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || '操作成功')
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName)
      })
      this.show_sortTableHeard = false //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
      this.show_sortTableHeard = false
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this
      that.tabelHeadeTitle[idx].isShow = e
      let selectLength = 0
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++
        }
      }
      that.selectLength = selectLength
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true
      } else {
        that.allCheck = false
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this
      this.allCheck = e
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e
      }
      let selectLength = 0
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++
        }
      }
      that.selectLength = selectLength
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e
    },

    /****
     *  ===================上面页面公共方法 end ===================
     *
     */
  },
}
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}

.dialogTims {
  /deep/ .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 150px !important;
  }
}
</style>
